module.exports = __webpack_public_path__ + "media/images/navbar-logo-8c3b30cbf539c5fec5cbb93fc672f642.webp";